import styled from 'styled-components';
import { Button, Dropdown, Form } from 'semantic-ui-react'

export const StyledGroup = styled(Form.Group)`
 .field {
  margin-bottom: 1em !important;
 }
 .eight {
  padding-left: 0 !important;
 }
 gap: 15px;
 .phone {
  align-items: end;
  margin: 0 -0.5em 0em !important;
 }
`
export const StyledBlockButton = styled(Button)`
color: red !important !important;
`
export const StyledFilterDropdown = styled(Dropdown)`
margin-right: 10px;
width: 200px;
 .divider.default.text {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
 }
`
export const StyledFiltersOptions = styled(Dropdown)`
font-size: 1.2rem !important;
 .divider.text {
  margin: 0.45238095em 0 0.45238095em -1em !important; 
 }
 .menu.transition {
   margin-left: -6em !important;
    .item {
      padding: 0px !important;
    }
 }

 .ui.checkbox {
   padding : .78571429rem 1.14285714rem !important;
   width: 100%;
 }
`
export const StyledFilterWrapper = styled.div`
display: flex;
align-items: baseline;
justify-content: end;
flex-wrap: wrap;
gap: 10px;
`
export const FilterWrapper = styled.div`
display: flex;
align-items: baseline;
flex-wrap: wrap;
gap: 10px;
`
export const StyledField = styled(Form.Field)`
 .field{ 
margin-bottom: 0px !important;
}
`

export const InputWrapper = styled.div`
display: flex; 
align-items: center;
justify-content: center;
width: 100%;
 .loaderWrapper {
  position: relative; 
  margin: auto;
  margin-left: 10px; 
  margin-top: 23px; 
  margin-right: 5px;
 }
 .field {
  width: inherit !important;
 }
`